var _path, _path2, _g, _path3, _path4, _g2, _use, _use2, _g3, _use3, _use4, _use5, _use6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h600v400H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 0h240v400H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.2 262c-30.2-.9-168.7-87.3-169.6-101.1l7.6-12.8c13.7 20 155.4 104 169.3 101.1l-7.3 12.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6 146.4c-2.7 7.3 36.1 31.3 82.9 59.8 46.7 28.4 87 46 90 43.4l1.4-2.5c-.6.9-2 1.1-4 .5-12.7-3.6-45.6-18.8-86.4-43.5-40.8-24.7-76.3-47.5-81.8-57.2-.4-.7-.7-2-.6-2.9h-.2l-1.1 2-.2.4h0zm164.4 116c-.6 1-1.5 1-3.3.8-11.3-1.2-45.6-18-86.2-42.2-47.2-28.3-86.2-54-82-60.8l1.2-2h.2c-3.8 11.5 77 57.7 81.7 60.6 46.7 29 86.1 45.9 89.6 41.5l-1.3 2.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2 169.2c30.2-.2 67.5-4.1 89-12.7l-4.6-7.5c-12.7 7-50.2 11.7-84.7 12.4-40.7-.4-69.5-4.2-83.9-13.9l-4.3 8c26.4 11.2 53.6 13.6 88.5 13.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4 156.7c-.7 1.2-14.7 6-35.3 9.6a390.3 390.3 0 0 1-107.7.6c-21.7-3.4-32.9-8-37-9.8l1-2a160 160 0 0 0 36.3 9.6 385.7 385.7 0 0 0 107-.7c21-3.4 32.6-7.8 34.2-9.9l1.5 2.6h0zm-4-7.6c-2.3 1.8-13.7 5.9-33.8 9a364 364 0 0 1-52.3 3.8 351 351 0 0 1-50.5-3.3c-20.4-2.7-31.3-7.5-35.2-8.9l1.2-2c3 1.5 13.5 5.8 34.2 8.7 12.8 1.8 29.7 3.2 50.3 3.2 21.7 0 38.5-1.8 51.9-3.7 20.2-2.8 31-8 32.7-9.3l1.5 2.5v0zm-185.5 56.6c18.6 10 59.9 15 99 15.4 35.6 0 82-5.6 99.3-14.7l-.5-10c-5.4 8.4-55.1 16.6-99.2 16.2-44.1-.3-85-7.1-98.7-16v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.1 204.2v2.4c-2.6 3.1-19 7.8-39.4 11.1a407 407 0 0 1-61.3 4.2c-24 0-43.2-1.7-58.1-4a145 145 0 0 1-41.6-11.2V204c9 6 33.6 10.5 41.9 11.8 14.8 2.3 33.9 4 57.8 4a405 405 0 0 0 61-4.2c14.7-2 35.6-7.6 39.7-11.3h0zm0-8.5v2.4c-2.6 3.1-19 7.8-39.4 11.2a407 407 0 0 1-61.3 4.1c-24 0-43.2-1.7-58.1-4a145 145 0 0 1-41.6-11.2v-2.8c9 6 33.7 10.5 42 11.8a382 382 0 0 0 57.7 4c25.2 0 45.5-1.8 61-4.2 14.7-2 35.6-7.6 39.7-11.3h0zm-100.3 64.6c-42.8-.2-79.4-11.6-87.2-13.5l5.7 8.8a234 234 0 0 0 81.9 13.4c32.5-1 61-3.5 81-13.2l5.7-9.2c-13.6 6.4-60 13.7-87.1 13.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.3 253.7a134 134 0 0 1-2.6 3.8c-9.4 3.4-24.3 6.9-30.6 7.9a277 277 0 0 1-50.3 4.6c-37.9-.6-68.9-8-83.5-14.3l-1.1-2 .2-.3 2 .7c25.9 9.3 55 13 82.6 13.7 17.6 0 35.1-2 49.3-4.6 21.8-4.3 30.6-7.6 33.3-9l.7-.5h0zm5-8.3v.1l-1.9 3.3c-5 1.8-18.7 5.8-38.6 8.6-13.2 1.8-21.4 3.5-47.5 4-49-1.2-80.8-10.8-88.3-13.2l-1.1-2.1a372.4 372.4 0 0 0 89.4 13c24-.4 34.1-2.2 47.1-4 23.3-3.6 35-7.4 38.6-8.5l-.2-.2 2.5-1h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.8 197.8a95.5 95.5 0 0 1-25.8 64.5 93 93 0 0 1-63.6 26.3c-28.4.6-55.1-18-62.3-26a94.8 94.8 0 0 1-25.8-63.3c1.7-30.7 13.8-52 31.3-66.8s40.7-21.8 60-21.3a92 92 0 0 1 66.6 33.4c11.8 14.2 17 29.7 19.6 53.2zm-89.2-96.4a99.3 99.3 0 0 1 99.3 98.7 99 99 0 0 1-198.2 0 99 99 0 0 1 99-98.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 101c54.4 0 99 44.6 99 99.1 0 54.5-44.6 99-99 99-54.6 0-99.1-44.5-99.1-99s44.5-99 99-99zm-97 99.1a97.2 97.2 0 0 0 97 96.8 97.2 97.2 0 0 0 96.7-96.8c0-53.3-43.7-96.8-96.8-96.8s-96.8 43.5-96.8 96.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 109.3a91 91 0 0 1 90.7 90.7c0 49.9-41 90.7-90.7 90.7S149.3 250 149.3 200a91 91 0 0 1 90.7-90.7zM151.5 200c0 48.7 40 88.5 88.5 88.5s88.5-39.8 88.5-88.5-40-88.5-88.5-88.5a88.9 88.9 0 0 0-88.5 88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 100.7h-8.5v199h8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1 99.5h2.2v201.3h-2.2V99.5zm-8.4 0h2.2v201.3h-2.2V99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 204v-7.4l-6-5.6-34-9-49-5-59 3-42 10-8.5 6.3v7.3L162 194l51-8h49l36 4 25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 184.8c23.3 0 46 2.2 64 5.7 18.6 3.7 31.7 8.3 36.1 13.6v2.5c-5.4-6.4-23-11.2-36.5-14a341.3 341.3 0 0 0-63.7-5.6c-24.5 0-47.3 2.4-65 5.8-14 2.8-32.9 8.4-35.2 13.9V204c1.3-3.8 15.3-9.5 35-13.4 17.7-3.5 40.6-5.8 65.3-5.8zm0-8.5c23.3 0 46 2.2 64 5.7 18.6 3.7 31.7 8.4 36.1 13.6v2.6c-5.4-6.5-23-11.3-36.5-14a341 341 0 0 0-63.6-5.7 353 353 0 0 0-65 5.8c-13.5 2.6-33.1 8.4-35.3 13.9v-2.7c1.3-3.8 15.6-9.7 35-13.4 17.7-3.5 40.6-5.8 65.3-5.8zm-.5-43.3c36.8-.2 69 5.1 83.7 12.6l5.3 9.3c-12.7-6.9-47.4-14-89-13-33.8.3-70 3.8-88.1 13.5l6.4-10.8c14.9-7.7 50-11.6 81.7-11.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 140.6c21 0 41.3 1.1 57.4 4 15 2.9 29.4 7 31.5 9.3l1.6 2.8c-5-3.2-17.4-6.8-33.4-9.9-16-3-36.3-4-57.2-4-23.7 0-42.1 1.2-58 4a102.3 102.3 0 0 0-31.1 9.7l1.5-3a104 104 0 0 1 29.2-8.9c16.4-3 35-3.9 58.5-4h0zm0-8.5c20 0 40 1.1 55.4 3.9 12.2 2.4 24.3 6 28.7 9.4l2.3 3.7c-4-4.4-18.8-8.6-32-11a353.1 353.1 0 0 0-54.4-3.8c-21.1 0-40.7 1.4-55.8 4.1a90.8 90.8 0 0 0-27.7 8.6l2-3.1a99 99 0 0 1 25.4-7.7 334 334 0 0 1 56-4zm49.1 109.2a258.5 258.5 0 0 0-49.2-3.8c-61.4.7-81.2 12.6-83.6 16.2l-4.6-7.5c15.6-11.3 49-17.6 88.6-17 20.5.3 38.2 1.7 53 4.6l-4.2 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6 236.5c17 .2 33.8 1 50 4l-1.2 2c-15-2.8-31-3.8-48.8-3.7a236 236 0 0 0-65.5 7.6c-6.3 1.8-16.7 5.8-17.8 9.2l-1.2-2c.4-2 6.7-6 18.5-9.3 22.8-6.6 44.2-7.7 66-7.8v0zm.8-8.6c17.7.3 36 1.1 53.7 4.6l-1.2 2.2c-16-3.2-31.4-4.3-52.4-4.6-22.8 0-46.9 1.7-68.8 8-7.1 2.1-19.3 6.6-19.7 10.1l-1.2-2c.3-3.3 10.9-7.5 20.4-10.2 22-6.4 46.2-8.1 69.2-8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.6 247.4-7.4 11.4L299 240l-55-37-62-34-32.2-11 6.9-12.7 2.3-1.3 20 5 66 34 38 24 32 23 13 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7 158.3c5.6-3.8 47 14.6 90.5 40.8 43.3 26.3 84.7 56 81 61.5l-1.3 2-.5.4c0-.1.7-.9-.1-3-1.9-6-31.2-29.4-79.9-58.8-47.5-28.3-87-45.4-91-40.5l1.3-2.4h0zm180.4 89c3.6-7.1-35-36.1-82.6-64.4-48.9-27.6-84-44-90.5-39l-1.4 2.5c0 .2 0-.1.4-.4 1.1-1 3-1 4-1 11 .2 42.6 14.8 87 40.2 19.4 11.3 82 51.5 81.8 62.8 0 1 0 1.2-.3 1.6l1.6-2.4v0z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M180.6 211c0 16.3 6.7 31 17.5 41.8A59.1 59.1 0 0 0 299.3 211v-79.2l-118.7-.2V211z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M182.8 211.1a57 57 0 0 0 114 0v-76.7h-114V211m91-53.7v54c0 1.4 0 3-.2 4.3a34 34 0 0 1-33.8 29.6 34 34 0 0 1-33.9-34v-54h68z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M190.2 154.4c.1-5.5 4-6.8 4-6.8.1 0 4.3 1.4 4.3 6.9h-8.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.8 147.7-.7 6.3h4.2c0-5.2 4-6 4-6 .1 0 4 1.1 4.1 6h4.2l-.8-6.3h-15zm-1 6.3h17c.4 0 .6.4.6.8 0 .5-.2.8-.6.8h-17c-.3 0-.6-.3-.6-.8 0-.4.3-.7.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 154c0-3.3 2.3-4.2 2.3-4.2s2.3 1 2.3 4.2H192m-5.8-9h16.3c.3 0 .6.4.6.8 0 .3-.3.7-.6.7h-16.3c-.3 0-.6-.4-.6-.7 0-.4.3-.8.6-.8zm.4 1.5H202c.3 0 .6.3.6.7 0 .4-.3.7-.6.7h-15.5c-.4 0-.6-.3-.6-.7 0-.4.2-.7.6-.7zm5-10.6h1.2v.9h.9v-1h1.2v1h1v-1h1.2v2c0 .4-.3.6-.5.6H192c-.3 0-.5-.2-.5-.5v-2zm4.6 2.7.3 6.4h-4.3l.2-6.4h3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M191 141.6v3.4h-4v-3.4h4z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M186.3 139h1.2v1h.9v-1h1.2v1h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.3a.6.6 0 0 1-.6-.6v-2z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "M193.9 140.6c0-.6.9-.6.9 0v1.5h-.9v-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    fill: "#000",
    stroke: "none",
    d: "M188.6 142.8c0-.6.8-.6.8 0v1.2h-.8v-1.2"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 10.6
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    y: 46.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-45.2 312.8 180)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 45.7
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "matrix(-1 0 0 1 479.8 0)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M232.6 202.4c0 2.2.9 4.2 2.2 5.7a7.2 7.2 0 0 0 5.3 2.4c2.1 0 4-1 5.4-2.4a8.3 8.3 0 0 0 2.2-5.7v-10.7h-15v10.7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.1,
    cy: 195.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.4,
    cy: 195.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.2,
    cy: 199.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.1,
    cy: 203.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.4,
    cy: 203.9,
    r: 1.5
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    y: -26
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: -20.8
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 20.7
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    y: 25.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.efdb2fd20631a387110b1c1c99dd46ea.svg";
export { ForwardRef as ReactComponent };